'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//flow
var Calendar = function Calendar(props) {
	return _react2.default.createElement(
		'div',
		{ className: _style2.default.calendar },
		_react2.default.createElement(
			'div',
			{ className: _style2.default.header + ' clearfix' },
			_react2.default.createElement(
				'div',
				{ className: _style2.default.colSidebar },
				'-'
			),
			props.availabilities.map(function (day, index) {
				return _react2.default.createElement(
					'div',
					{ key: index, className: [_style2.default.col, index === 0 ? _style2.default.col0 : null].join(' ') },
					_react2.default.createElement(
						'span',
						null,
						day.date
					)
				);
			})
		),
		_react2.default.createElement(
			'div',
			{ className: _style2.default.body + ' clearfix' },
			_react2.default.createElement(
				'div',
				{ className: _style2.default.colSidebar },
				_react2.default.createElement(
					'span',
					null,
					'Morning'
				),
				_react2.default.createElement(
					'span',
					null,
					'Afternoon'
				),
				_react2.default.createElement(
					'span',
					null,
					'Evening'
				)
			),
			props.availabilities.map(function (day, index) {
				return _react2.default.createElement(
					'div',
					{ key: index, className: [_style2.default.col, index === 0 ? _style2.default.col0 : null].join(' ') },
					day.availableMorning ? _react2.default.createElement(
						_reactRouter.Link,
						{ to: props.profileUrl,
							className: _style2.default.slot,
							onClick: function onClick() {
								(0, _doctifyUtils.fireGTMevent)('patient_booking_calendar_srp_step1', '/specialist/' + props.profileUrl);
							} },
						'Available'
					) : _react2.default.createElement(
						'span',
						{ className: _style2.default.empty },
						_react2.default.createElement(
							'p',
							null,
							'Empty'
						)
					),
					day.availableAfternoon ? _react2.default.createElement(
						_reactRouter.Link,
						{ to: props.profileUrl,
							className: _style2.default.slot,
							onClick: function onClick() {
								(0, _doctifyUtils.fireGTMevent)('patient_booking_calendar_srp_step1', '/specialist/' + props.profileUrl);
							} },
						'Available'
					) : _react2.default.createElement(
						'span',
						{ className: _style2.default.empty },
						_react2.default.createElement(
							'p',
							null,
							'Empty'
						)
					),
					day.availableEvening ? _react2.default.createElement(
						_reactRouter.Link,
						{ to: props.profileUrl,
							className: _style2.default.slot,
							onClick: function onClick() {
								(0, _doctifyUtils.fireGTMevent)('patient_booking_calendar_srp_step1', '/specialist/' + props.profileUrl);
							} },
						'Available'
					) : _react2.default.createElement(
						'span',
						{ className: _style2.default.empty },
						_react2.default.createElement(
							'p',
							null,
							'Empty'
						)
					)
				);
			}),
			props.nextAvailableAt && _react2.default.createElement(
				'div',
				{ className: _style2.default.nextAvailable },
				_react2.default.createElement(
					_reactRouter.Link,
					{ to: props.profileUrl, className: 'btn ' + _style2.default.viewProfileBtn },
					_react2.default.createElement('i', { className: 'ion-android-clipboard' }),
					'Available: ',
					props.nextAvailableAt.format('MMM Do,YYYY')
				)
			)
		)
	);
};

Calendar.propTypes = {
	availabilities: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
	profileUrl: require('react').PropTypes.any
};
Calendar.defaultProps = {
	availabilities: []
};
exports.default = Calendar;


// WEBPACK FOOTER //
// ./components/search-results/lib/components/calendar.js